import React from "react";

// Shared by the prerendered boot screen and the application's global styles.
export const SPINNER_CSS = `
  @keyframes examnova-spin { to { transform: rotate(360deg); } }
  [data-app-spinner="true"] { animation: examnova-spin 0.8s linear infinite; }
  @media (prefers-reduced-motion: reduce) {
    [data-app-spinner="true"] { animation: none; }
  }
`;

// No theme or stylesheet dependency for the ring's first paint. Keep this
// usable by Node's HTML prerenderer as well as page and inline React loaders.
export default function Spinner({ size = 48, style, ...props }) {
  return React.createElement("span", {
    "aria-hidden": props.role ? undefined : true,
    ...props,
    "data-app-spinner": "true",
    style: {
      display: "inline-block", boxSizing: "border-box",
      width: size, height: size, flexShrink: 0, verticalAlign: "middle",
      border: `${Math.max(2, Math.round(size / 12))}px solid rgba(148, 163, 184, 0.18)`,
      borderTopColor: "var(--primary, #818cf8)", borderRadius: "50%",
      ...style,
    },
  });
}
